import script from "./PointHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointHistory.vue?vue&type=script&lang=ts&setup=true"

import "./PointHistory.vue?vue&type=style&index=0&id=9ea27bfa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ea27bfa"]])

export default __exports__